module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/modules/_is-object.js
// module id = 231
// module chunks = 0